// src/stone/icons/FlipUp.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FlipUp = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.466 8.4H10.665a2.85 2.85 0 0 0-2.692 3.786l1.61 4.629a2.1 2.1 0 0 0 1.983 1.41h11.309v-1.2H11.566a.9.9 0 0 1-.85-.604l-.566.197.566-.197-1.61-4.629A1.65 1.65 0 0 1 10.665 9.6h11.801z" }),
      /* @__PURE__ */ jsx("path", { d: "M12.213.527A11.475 11.475 0 0 0 .524 12v2.966a8.51 8.51 0 0 0 8.509 8.509h8.911a5.657 5.657 0 0 0 5.53-5.676v-5.797A11.395 11.395 0 0 0 12.212.527m-.01.6-.006.6a10.194 10.194 0 0 1 10.078 10.269v5.806a4.457 4.457 0 0 1-4.35 4.473H9.033a7.31 7.31 0 0 1-7.31-7.31V12A10.275 10.275 0 0 1 12.193 1.727z" })
    ]
  }
);
var FlipUp_default = FlipUp;

export {
  FlipUp_default
};
